import { render, staticRenderFns } from "./BenefitLimitSelector.vue?vue&type=template&id=08c6f7e2&scoped=true"
import script from "./BenefitLimitSelector.vue?vue&type=script&lang=js"
export * from "./BenefitLimitSelector.vue?vue&type=script&lang=js"
import style0 from "./BenefitLimitSelector.vue?vue&type=style&index=0&id=08c6f7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c6f7e2",
  null
  
)

export default component.exports